<script setup lang="ts"></script>

<template>
  <svg width="106" height="149" viewBox="0 0 106 149" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.7439 8.73615C0 12.1587 0 16.6392 0 25.6V123.4C0 132.361 0 136.841 1.7439 140.264C3.27787 143.274 5.72556 145.722 8.73615 147.256C12.1587 149 16.6392 149 25.6 149H80.4C89.3608 149 93.8413 149 97.2638 147.256C100.274 145.722 102.722 143.274 104.256 140.264C106 136.841 106 132.361 106 123.4V25.6L80.4 0H25.6C16.6392 0 12.1587 0 8.73615 1.7439C5.72556 3.27787 3.27787 5.72556 1.7439 8.73615Z"
      class="fill-white dark:fill-gray-850"
    />
    <path
      class="fill-gray-300 dark:fill-gray-650"
      d="M89.1362 23.8557C92.5587 25.5996 97.0392 25.5996 106 25.5996L80.4 -0.000393244C80.4 8.96045 80.4 13.4409 82.1439 16.8635C83.6779 19.874 86.1256 22.3217 89.1362 23.8557Z"
    />
  </svg>
</template>
